// views
import { Alert } from "antd";
import Link from "next/link";

// utils
import { hasContactInfo } from "~/utils/user";

export default (props) => {
  if (!props.user) {
    return null;
  }

  if (hasContactInfo(props.user)) {
    return null;
  }

  const message = (
    <div>
      <span>您还没有填写个人联系方式，其它人将无法联系到您。</span>
      <span className="pl-10">
        <Link legacyBehavior href="/profile/edit">
          <a className="text-primary">立即填写</a>
        </Link>
      </span>
    </div>
  );

  return <Alert type="warning" message={message} className="mt-20" />;
};
